// extracted by mini-css-extract-plugin
var _1 = "BookScrollTheme__area--gRR6T";
var _2 = "BookScrollTheme__content--sy_bd";
var _3 = "BookScrollTheme__pos--vnrtq";
var _4 = "BookScrollTheme__xBar--_EMzn";
var _5 = "BookScrollTheme__xThumb--Z4gh9";
var _6 = "BookScrollTheme__yBar--lPhWe";
var _7 = "BookScrollTheme__yThumb--rR7uJ";
export { _1 as "area", _2 as "content", _3 as "pos", _4 as "xBar", _5 as "xThumb", _6 as "yBar", _7 as "yThumb" }
